<template>
  <div class="myRequestListBackground">
    <mdb-container class="my-request-list mb-5" v-if="user">
      <mdb-row>
        <mdb-col>
          <div class="bg-white p-3 rounded">
            <h1 class="my-request-list__heading">My Request List</h1>
            <template v-if="hasAnyItem">
              <p>
                You have selected the following test studios for your
                <strong>{{ requestListTestTypeName }}</strong
                >.<template v-if="user.role == 1">
                  <span class="d-md-block"></span>To get a quotation, just send
                  your non-binding request to isi.</template
                >
              </p>
            </template>
            <template v-if="!hasAnyItem">
              <p>
                Your request list is empty. You can add test studios to this
                list by clicking 'Add to request list' on the studio items you
                want to add.
              </p>
            </template>
          </div>
        </mdb-col>
      </mdb-row>
      <mdb-row class="mt-3">
        <mdb-col>
          <test-studio
            v-for="testStudio in myRequestListTestStudios.items"
            :item="testStudio"
            layout="myRequestList"
            :details="myRequestListTestStudios.details"
            :key="'testStudio-' + testStudio.id"
          />
          <custom-location
            v-for="customLocation in requestListCustomLocations"
            :key="customLocation.id"
            @removeCustomLocation="removeCustomLocation($event)"
            :customLocation="customLocation"
          ></custom-location>
        </mdb-col>
      </mdb-row>
      <mdb-row v-show="hasAnyItem">
        <mdb-col class="d-flex justify-content-center justify-content-lg-end">
          <router-link to="/requestSetup">
            <mdb-btn color="orange" class="mr-0">{{ continueBtnText }}</mdb-btn>
          </router-link>
        </mdb-col>
      </mdb-row>
    </mdb-container>
    <app-footer />
  </div>
</template>

<script>
import TestStudio from "../components/TestStudio/TestStudio.vue";
import CustomLocation from "../components/CustomLocation/CustomLocation.vue";
import AppFooter from "../components/Footer.vue";

export default {
  components: { TestStudio, CustomLocation, AppFooter },
  name: "MyRequestList",
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "My Request List",
    // all titles will be injected into this template
    titleTemplate: "%s | isi Test Studio Finder",
  },
  created() {
    this.$http({
      method: "post",
      url: "/api/AppData/CheckAndFixRequestList",
    }).then((resp) => {
      if (resp.data == "fixed") {
        // sollte nicht vorkommen
        this.$store
          .dispatch("logoutUser", this.$http)
          .then(() => {
            this.$router.go("Search");
          })
          .catch((e) => {
            console.log(e);
          });
      }
    });
  },
  methods: {
    removeCustomLocation({ customLocationId }) {
      this.$http({
        method: "POST",
        url: "/api/CustomLocation/RemoveCustomRequestListItem",
        data: {
          customLocationId: customLocationId,
        },
      })
        .then(() => {
          this.$store.commit("removeCustomLocationFromRequestList", {
            customLocationId,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  computed: {
    continueBtnText() {
      return this.overallItemCount > 1
        ? "CONTINUE WITH THESE STUDIOS"
        : "CONTINUE WITH THIS STUDIO";
    },
    user() {
      return this.$store.state.user;
    },
    requestListTestTypeName() {
      return this.$store.state.testTypes.find(
        (x) => x.id == this.user.requestList.testType
      ).displayName;
    },
    myRequestListTestStudios() {
      return this.$store.getters.myRequestListTestStudios;
    },
    requestListCustomLocations() {
      return this.$store.getters.requestListCustomLocations;
    },
    overallItemCount() {
      return (
        this.user.requestList.testStudioIds.length +
        this.user.requestList.customLocations.length
      );
    },
    hasItems() {
      return this.user.requestList.testStudioIds.length > 0;
    },
    hasCustomItems() {
      return this.user.requestList.customLocations.length > 0;
    },
    hasAnyItem() {
      return this.hasItems || this.hasCustomItems;
    },
  },
};
</script>

<style lang="scss">
@import "../styles/views/_myRequestList.scss";
</style>